import { GoogleProfile } from "../../googleprofile/googleprofile";

export function GoogleCalendarStage(props) {
    return <>
    <GoogleProfile />
    </>
}